import React, { useState, useEffect } from "react";
import Card from "components/card";
import { fetchData } from "../../../../services/ApiFetching";
import LineChart from "components/charts/LineChart";

const TotalSpent = () => {

  const [lineChartDataTotalSpent, setLineChartDataTotalSpent] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchLineData = async () => {
    const response = await fetchData("dashboard/getLineGraph");
    if (response) {
      setLineChartDataTotalSpent(response);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchLineData();
  }, []);

  const lineChartOptionsTotalSpent = {
    legend: {
      show: false,
    },
    theme: {
      mode: "light",
    },
    chart: {
      type: "line",
      toolbar: {
        show: false,
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      curve: "smooth",
    },
    tooltip: {
      style: {
        fontSize: "12px",
        backgroundColor: "#000000",
      },
      theme: "dark",
      x: {
        format: "dd/MM/yy HH:mm",
      },
    },
    grid: {
      show: false,
    },
    xaxis: {
      axisBorder: {
        show: false,
      },
      axisTicks: {
        show: false,
      },
      labels: {
        style: {
          colors: "#A3AED0",
          fontSize: "12px",
          fontWeight: "500",
        },
      },
      type: "text",
      categories: ["8h", "16h", "24h", "32h", "40h", "48h"],
    },
    yaxis: {
      show: false,
    },
  };


  return (
    <Card extra="!p-[20px] text-center">
      <div className="flex justify-between">
        <h2 className="text-lg font-bold text-navy-700 dark:text-white">
          SLA COMPLIANCE RATE
        </h2>
        <button className="px-4 !linear z-[1] flex items-center justify-center rounded-lg bg-lightPrimary p-2 text-brand-500 !transition !duration-200 hover:bg-gray-100 active:bg-gray-200 dark:bg-navy-700 dark:text-white dark:hover:bg-white/20 dark:active:bg-white/10">
          Last 48 Hours
        </button>
      </div>

      <div className="flex h-100 w-full flex-row justify-start gap-8 sm:flex-wrap lg:flex-nowrap 2xl:overflow-hidden pb-3 mt-5">
        <div className="flex flex-col">
          <p className="text-xl font-bold text-[#6AD2FF] dark:text-white">
            40%
          </p>
          <p className="text-sm text-navy-700 dark:text-white">Resolution Rate</p>
        </div>
        <div className="flex flex-col">
          <p className="text-xl font-bold text-red-600 dark:text-white">
            60%
          </p>
          <p className="text-sm text-navy-700 dark:text-white">Escalation Rate</p>
        </div>
      </div>
      <div className="h-full w-full">
        <LineChart
          options={lineChartOptionsTotalSpent}
          series={lineChartDataTotalSpent}
        />
      </div>
    </Card>
  );
};

export default TotalSpent;
